/**
 * Tipo y constantes para el sistema de tema NQORO.
 *
 * - `auto`: respeta `prefers-color-scheme` del SO/navegador.
 * - `dark`: fuerza dark mode (identidad NQORO premium).
 * - `light`: fuerza light mode (bg pergamino + text noir).
 */
export type Theme = 'auto' | 'dark' | 'light';
export type ResolvedTheme = 'dark' | 'light';

export const THEMES: readonly Theme[] = ['auto', 'dark', 'light'] as const;
export const THEME_COOKIE = 'nqoro-theme';
export const THEME_STORAGE_KEY = 'nqoro-theme';

export function isTheme(value: unknown): value is Theme {
  return value === 'auto' || value === 'dark' || value === 'light';
}

/**
 * Resuelve un Theme a su valor efectivo en HTML (`dark` | `light`).
 *
 * Si `prefersDark` se pasa, se usa como hint para 'auto'; si no, default a
 * `light` (decisión Naye 2026-06-04: el sitio entra en blanco para atender
 * la preocupación de "se siente muy oscuro" en lectura prolongada).
 */
export function resolveTheme(theme: Theme, prefersDark?: boolean): ResolvedTheme {
  if (theme === 'dark') return 'dark';
  if (theme === 'light') return 'light';
  return prefersDark === true ? 'dark' : 'light';
}
